var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isScrolling)?_c('v-btn',{staticClass:"top-btn",class:{
    'isFixed': _vm.fixed
  },attrs:{"fab":"","small":"","size":"40","color":"white"},on:{"click":_vm.goTop}},[_c('v-icon',[_vm._v("fas fa-chevron-up")]),_c('translate',[_vm._v("Up")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }